module.exports = __webpack_public_path__ + "static/media/drugOrdering.1724aba2.svg";